module.exports = __webpack_public_path__ + "img/icon-video.00dec521.svg";